import {
  type DataSetDto,
  instanceOfEnumerationDataSetDto,
  instanceOfNumericDataSetDto,
} from '@/api/generator';
import { highchartColors, highchartSymbols } from '@/components/TrendChart/utils.ts';
import { getSetupParameterName } from '@/views/tasks/utils.ts';
import { getEvaluationTypeString } from '@/views/TrendsDisplayView/utils.ts';

export function getLegendItems(dataSets?: DataSetDto[] | null) {
  let enumerationIndex: number = 0;
  let numericIndex: number = 0;

  return dataSets?.map((dataset) => {
    let title: string | undefined;
    let targetColor: string | undefined;
    let targetSymbol: string | undefined;
    let seriesType: 'enumeration' | 'numeric' = 'numeric';

    if (instanceOfEnumerationDataSetDto(dataset)) {
      const targetIndex = enumerationIndex++;
      seriesType = 'enumeration';
      targetColor =
        highchartColors[highchartColors.length - 1 - (targetIndex % highchartColors.length)];
      targetSymbol =
        highchartSymbols[highchartSymbols.length - 1 - (targetIndex % highchartSymbols.length)]
          .symbolSvg;
    } else if (instanceOfNumericDataSetDto(dataset)) {
      title = `${getSetupParameterName(dataset.evaluationParameter)} - ${getEvaluationTypeString(dataset.evaluationParameter)}`;
      const targetIndex = numericIndex++;
      targetColor = highchartColors[targetIndex % highchartColors.length];
      targetSymbol = highchartSymbols[targetIndex % highchartSymbols.length].symbolSvg;
    }

    return {
      title,
      seriesType: seriesType,
      color: targetColor,
      symbol: targetSymbol,
    };
  });
}
